import { pushRoute } from '../../lib/router.js';
import React from 'react';
import ProjectFilesSearchContainer from '../../containers/projects/ProjectFilesSearchContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import FileTable from '../files/FileTable.jsx';
import Empty from '../Empty.jsx';

import {
  linkedFilesContent,
  loadingContent,
  noResultsContent,
} from '../EmptyStates.jsx';

const ProjectFiles = ({
  loading,
  project,
  files,
  isSearching,
  searchRetrieveState,
}) => {
  const fileCount = files?.length || 0;

  const navigateToNewFile = () => {
    if (project.archived) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      pushRoute('files/new', { projectId: project.id });
    }
  };

  const renderHeader = () => {
    if (!project) return null;

    return (
      <ProjectFilesSearchContainer
        navigateToNewFile={navigateToNewFile}
        count={fileCount}
        projectId={project.id}
        project={project}
      />
    );
  };

  const renderFiles = () => {
    if (loading) return <Empty simplified content={loadingContent} />;

    if (fileCount > 0)
      return (
        <FileTable
          files={files}
          manageProjectEntities={project.manageProjectEntities}
          archived={project.archived}
        />
      );

    // Show "no results" when searching returns nothing
    if (isSearching && fileCount === 0) {
      return <Empty simplified content={noResultsContent} />;
    }

    // Only show initial empty state if search completed with 0 results and no query
    if (searchRetrieveState?.success && fileCount === 0 && !isSearching) {
      return (
        <Empty
          content={linkedFilesContent}
          action={navigateToNewFile}
          actionAuthorization={{ action: 'create', subject: 'linkedFile' }}
          addBtn
        ></Empty>
      );
    }

    // Show loading during pending state
    return <Empty simplified content={loadingContent} />;
  };

  return (
    <React.Fragment>
      {renderHeader()}
      {renderFiles()}
    </React.Fragment>
  );
};

export default ProjectFiles;
